import Button from '@components/Button';
import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import TextField from '@components/TextField';
import TextUnderline from '@components/TextUnderline';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import useRegisterCoupon from './hooks/useRegisterCoupon';

function PaperCouponFragment() {
    const { t } = useTranslation('coupon');
    const {
        errorMessage, code, coupon,
        handleGetCoupon, handleSetCode, handleRegisterCoupon,
    } = useRegisterCoupon();
    return (
        <Container fullWidth as='section' spacing={48}>
            <Row spacing={8} align='flex-start' fullWidth >
                <TextField placeholder={t('paperCoupon.placeholder')}
                    errorText={errorMessage}
                    value={code}
                    maxLength={12}
                    onChange={handleSetCode} />
                <GetButton size='sm' onClick={handleGetCoupon} >
                    {t('paperCoupon.search')}
                </GetButton>
            </Row>
            {coupon && (
                <CouponContainer>
                    <CouponContents spacing={12}>
                        <CouponImage src={coupon.couponImage}
                            width={100}
                            height={100} />
                        <Column spacing={12}>
                            <Column spacing={4}>
                                <TextUnderline>
                                    <Text size='s'>{coupon.availableShops}</Text>
                                </TextUnderline>
                                <Text size='lg' fontWeight='medium'>{coupon.couponName}</Text>
                            </Column>
                            <Text color={colors.textSecondary}>
                                {t('validity', { date: dayjs(coupon.expiresAt).format('YYYY.MM.DD') })}
                            </Text>
                        </Column>
                    </CouponContents>
                    <RegisterButton fullWidth onClick={handleRegisterCoupon}>
                        {t('paperCoupon.registerButton')}
                    </RegisterButton>
                </CouponContainer>
            )}
        </Container>
    );
}

const Container = styled(Column)`
    padding: 16px 20px;
`;

const GetButton = styled(Button)`
    padding: 8px 16px;
    height: 40px !important;
    border-radius: 8px;
`;

const CouponImage = styled(Image)`
    background-color: var(--color-white);
    border-radius: 12px;
    border: 1px solid var(--color-gray4);
`;

const CouponContainer = styled.div`
    width: 100%;
    border-radius: 8px;
    background-color: var(--color-gray1);
    overflow: hidden;
`;

const CouponContents = styled(Row)`
    padding: 20px 16px;
`;

const RegisterButton = styled(Button)`
    border-radius: 0;
`;

export default PaperCouponFragment;
